import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  History,
  Plus,
  Eye,
  Pencil,
  Trash2,
  Copy,
  FileText,
  Upload,
} from "lucide-react";
import { Badge } from "@/components/ui/badge";

const ICONS = {
  created: Plus,
  viewed: Eye,
  revealed: Eye,
  updated: Pencil,
  deleted: Trash2,
  copied: Copy,
  imported: Upload,
};
const COLORS = {
  created: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
  viewed: "text-slate-400 bg-slate-800 border-slate-700",
  revealed: "text-cyan-400 bg-cyan-500/10 border-cyan-500/30",
  updated: "text-amber-400 bg-amber-500/10 border-amber-500/30",
  deleted: "text-rose-400 bg-rose-500/10 border-rose-500/30",
  copied: "text-cyan-400 bg-cyan-500/10 border-cyan-500/30",
  imported: "text-emerald-400 bg-emerald-500/10 border-emerald-500/30",
};
const LABEL = {
  created: "OLUŞTURDU",
  viewed: "GÖRÜNTÜLEDİ",
  revealed: "AÇIĞA ÇIKARDI",
  updated: "DÜZENLEDİ",
  deleted: "SİLDİ",
  copied: "KOPYALADI",
  imported: "İÇE AKTARDI",
};

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/audit", { params: { limit: 200 } });
        setLogs(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6">
        <div className="text-[10px] font-mono uppercase tracking-widest text-cyan-400 mb-1">
          Şeffaflık
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-50 flex items-center gap-3">
          <History className="w-7 h-7 text-cyan-400" />
          Denetim Kaydı
        </h1>
        <p className="text-sm text-slate-400 mt-1">
          Kim, ne zaman, hangi kayıt üzerinde işlem yaptı — tüm hareketler.
        </p>
      </div>

      {loading ? (
        <div className="space-y-2">
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              className="h-16 rounded-xl bg-[#111726] border border-slate-800 animate-pulse"
            />
          ))}
        </div>
      ) : logs.length === 0 ? (
        <div className="p-12 rounded-2xl bg-[#111726] border border-slate-800 text-center">
          <FileText className="w-10 h-10 mx-auto text-slate-600 mb-4" />
          <div className="text-slate-300">Henüz kayıt yok</div>
        </div>
      ) : (
        <div className="space-y-2" data-testid="audit-log-list">
          {logs.map((l) => {
            const Icon = ICONS[l.action] || FileText;
            return (
              <div
                key={l.log_id}
                data-testid={`audit-row-${l.log_id}`}
                className="flex items-center gap-4 p-4 rounded-xl bg-[#111726] border border-slate-800"
              >
                <div
                  className={`w-9 h-9 rounded-lg border flex items-center justify-center flex-shrink-0 ${COLORS[l.action]}`}
                >
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm text-slate-100 truncate">
                    <span className="text-slate-300 font-medium">{l.user_name}</span>{" "}
                    <Badge
                      variant="outline"
                      className={`mx-1 font-mono text-[10px] uppercase tracking-widest ${COLORS[l.action]}`}
                    >
                      {LABEL[l.action] || l.action.toUpperCase()}
                    </Badge>
                    {l.secret_title && (
                      <span className="text-slate-400 font-mono text-xs">
                        → {l.secret_title}
                      </span>
                    )}
                  </div>
                  <div className="text-[11px] font-mono text-slate-500 mt-0.5">
                    {new Date(l.created_at).toLocaleString("tr-TR")}
                    {l.ip && <span> · {l.ip}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
